import styled from 'styled-components';
import { COLOR_BLACK, COLOR_RED, COLOR_ORANGE } from '../../assets/styles/colors';
import { BP_MOBILE_MAX } from '../../assets/styles/breakpoints';
import { rgba } from 'polished';
import CheckboxWrapSC from '../../components/ui/checkbox/checkbox.styled';

export default styled.div`
  a.document-link {
    color: ${COLOR_BLACK};
    display: inline-flex;
    align-items: center;
    gap: 5px;
    position: relative;
    text-decoration: none;
    transition: all 0.2s linear;

    &::before {
      position: absolute;
      content: '';
      width: 100%;
      height: 1px;
      background: ${COLOR_BLACK};
      bottom: 3px;
      transition: all 0.2s linear;
    }

    svg {
      width: 13px;
      height: 13px;
      path {
        transition: all 0.2s linear;
      }
    }

    &:hover {
      color: ${rgba(COLOR_BLACK, 0.6)};
      text-decoration: none;

      &::before {
        background: ${rgba(COLOR_BLACK, 0.6)};
      }

      svg {
        path {
          stroke: ${rgba(COLOR_BLACK, 0.6)};
        }
      }
    }
  }

  .row {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    .heading-block {
      text-transform: uppercase;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 25px;
      width: 100%;
      .separator {
        border-radius: 2px;
        background-color: #d9d8dd;
        height: 1px;
        width: 100%;
      }
      p {
        min-width: fit-content;
        padding-right: 20px;
      }
    }

    .half-block {
      padding-top: 15px;
      width: calc(50% - 10px);
    }
    .full-block {
      padding-top: 15px;
      width: 100%;
    }

    .form-submit {
      width: 100%;
      margin: 15px 0 10px 0;
    }
  }

  .react-select-error {
    &__control {
      border-color: #f71d1d !important;
    }
  }
  .react-select,
  .react-select-error {
    &__menu {
      box-shadow: none !important;
      color: #3f3d56;
      top: 45px;
      overflow: hidden;
      border: 1px solid #3f3d56;
      border-radius: 12px;

      &-list {
        padding-top: 10px;
        padding-bottom: 10px;
        max-height: 118px;

        div {
          padding: 5px 16px 4px 16px;
        }
      }

      .react-select__option {
        &--is-focused {
          color: rgba(63, 61, 86, 0.6);
        }
        &--is-selected {
          color: ${COLOR_ORANGE};
        }
        &:hover {
          color: ${COLOR_ORANGE};
        }
      }
    }
    &__option {
      color: rgba(63, 61, 86, 0.6);
      font-size: 18px;

      cursor: pointer;
      background: none;
      &:focus,
      &:active {
        background: none;
        color: rgba(63, 61, 86, 0.6);
      }
      &:hover {
        background: none;
        color: ${COLOR_ORANGE};
      }
    }
    &__control {
      cursor: pointer;
      border: 1px solid rgba(63, 61, 86, 0.4);
      border-radius: 12px;
      background-color: #ffffff;
      min-width: 100%;
      height: 50px;
      padding: 0px 0 0 12px;
      margin-bottom: -15px;
      outline: none;
      box-shadow: none;
      float: left;

      &:hover,
      &:active,
      &:focus {
        outline: none;
        border-color: #000000 !important;
        box-shadow: none;
      }
      &--is-focused {
        border-color: #000000 !important;
      }
    }
    &__value-container {
      padding: 0;
    }
    &__single-value {
      top: 50%;
      color: #000000;
      font-size: 18px;
    }
    &__placeholder {
      font-size: 18px;
      color: #3f3d56;
      opacity: 0.5;
      font-weight: 600;
      line-height: normal;
    }
    &__indicator-separator {
      display: none;
    }
    &__dropdown-indicator {
      padding-right: 15px;
      cursor: pointer;
    }
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    .row {
      .half-block {
        width: 100%;
      }
    }
  }

  ${CheckboxWrapSC} {
    small {
      max-width: 700px;

      span {
        max-width: none;
      }
    }
  }
`;

export const PersonalFormTextInputSC = styled.input`
  border-radius: 2px;
  min-width: 100%;
  width: 100%;
  padding: 12px 15px;
  border: 1px solid rgba(63, 61, 86, 0.4);
  background-color: #ffffff;
  font-size: 18px;
  line-height: 24px;
  border-radius: 12px;
  -webkit-appearance: none;

  &:read-only {
    opacity: 0.5;
    &:hover,
    &:focus {
      opacity: 0.5;
      border: 1px solid rgba(63, 61, 86, 0.4);
      outline: none;
      box-shadow: none;
    }
  }

  &::placeholder {
    color: #3f3d56;
    opacity: 0.3;
    font-weight: 400;
  }

  &:focus,
  &:hover {
    border: 1px solid #000000;
    outline: none;
    box-shadow: none;
    ${(props) => (props.hasError ? `border-color: ${COLOR_RED};` : 'border-color: #000000;')}
  }

  ${(props) => (props.hasError ? `color: ${COLOR_RED};` : null)}
  ${(props) => (props.hasError ? `border-color: ${COLOR_RED}` : null)}
`;

export const PersonalFormErrorSC = styled.div`
  width: 100%;
  height: auto;
  color: ${COLOR_RED};
`;
